// @flow

import SecurityContext from './SecurityContext';

export default class BookingPermissions {

  canReadBook(proRole:ProRole = null) {
    return SecurityContext.havePermission(
      'booking.book',
      proRole
    );
  }

  canCreateBooking(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canCreateBooking',
      proRole
    );
  }

  canCreateBookingOverLimit(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canCreateBookingOverLimit',
      proRole
    );
  }

  canEditBooking(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canEditBooking',
      proRole
    );
  }

  canConfirmWaitingBooking(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canConfirmWaitingBooking',
      proRole
    );
  }

  canCancelBooking(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canCancelBooking',
      proRole
    );
  }

  canFinalizeBooking(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canFinalizeBooking',
      proRole
    );
  }

  canMarkBookingAsSeen(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canMarkBookingAsSeen',
      proRole
    );
  }

  canEditPeriodStateForDay(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.book.canEditPeriodStateForDay',
      proRole
    );
  }

  canReadBookingSettings(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.settings',
      proRole
    );
  }

  canEditBookingSettings(proRole:ProRole = null): boolean {
    return SecurityContext.havePermission(
      'booking.settings.canEditSettings',
      proRole
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/utils/permissions/BookingPermissions.js